import React from 'react';
import ReactDOM from 'react-dom';
import JoinUsButton from './components/join_us_button/JoinUsButton';

document.addEventListener('DOMContentLoaded', () => {
  const buttonElement = document.getElementById('react-join-us-button');
  ReactDOM.render(
    <JoinUsButton />,
    buttonElement,
  );
});
